// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.share-iframe-link-modal__container .modal__container{
    padding: unset;
    max-width: unset;
    
}

.share-iframe-link-modal__content{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px;
}

.share-iframe-link-modal__container-create.baloa-name{
    justify-content: center;
    color: var(--primary-very-dark-color);
    font-size: 17px;
    text-align: center;
    margin-left: 15px;
    margin-right: 15px;
    
}

.share-iframe-link-modal__buttons{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
    padding: 16px;
    border-top: 1px solid var(--new-input-background-color);
}

.share-iframe-link-modal__content .baloa-table-column{
    color: var(--primary-very-dark-color);
}

.share-iframe-link-modal__description{
    display: flex;
    align-items: center;
    width: 80%;
    gap: var(--space);
}

.share-iframe-link-modal__description .hubicon-code{
    font-size: 35px;
    color: var(--basic-gray-color);
}

.share-iframe-link-modal__link{
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 24px;
    max-width: 80%;
    
}

.share-iframe-link-modal__link .baloa-table{
    background: var(--new-background-color);
    padding: 11px;
    border-radius: 4px;
    overflow: auto;
    height: 120px;
    word-break: break-word;
}

.icon-copy-86{
    margin-left: 12px;
    background-color: var(--white-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .share-iframe-link-modal__description .hubicon-code {
        margin-right: var(--space-half);
    }

    .share-iframe-link-modal__buttons {
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/share-iframe-link-modal/ShareIframeLinkModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uDAAuD;AAC3D;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,uCAAuC;IACvC,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,+BAA+B;IACnC;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["\n.share-iframe-link-modal__container .modal__container{\n    padding: unset;\n    max-width: unset;\n    \n}\n\n.share-iframe-link-modal__content{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    padding: 32px;\n}\n\n.share-iframe-link-modal__container-create.baloa-name{\n    justify-content: center;\n    color: var(--primary-very-dark-color);\n    font-size: 17px;\n    text-align: center;\n    margin-left: 15px;\n    margin-right: 15px;\n    \n}\n\n.share-iframe-link-modal__buttons{\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 16px;\n    border-top: 1px solid var(--new-input-background-color);\n}\n\n.share-iframe-link-modal__content .baloa-table-column{\n    color: var(--primary-very-dark-color);\n}\n\n.share-iframe-link-modal__description{\n    display: flex;\n    align-items: center;\n    width: 80%;\n    gap: var(--space);\n}\n\n.share-iframe-link-modal__description .hubicon-code{\n    font-size: 35px;\n    color: var(--basic-gray-color);\n}\n\n.share-iframe-link-modal__link{\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-top: 24px;\n    max-width: 80%;\n    \n}\n\n.share-iframe-link-modal__link .baloa-table{\n    background: var(--new-background-color);\n    padding: 11px;\n    border-radius: 4px;\n    overflow: auto;\n    height: 120px;\n    word-break: break-word;\n}\n\n.icon-copy-86{\n    margin-left: 12px;\n    background-color: var(--white-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .share-iframe-link-modal__description .hubicon-code {\n        margin-right: var(--space-half);\n    }\n\n    .share-iframe-link-modal__buttons {\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
